'use client';

import { c as _c } from "react/compiler-runtime";
import type { PinnedFactiii } from '@shared/all/domains/factiiis';
import type { Post } from '@shared/all/domains/posts';
import { Camera } from '../../common/Camera';
import { DragOverlay } from './DragOverlay';
import { ModerationConfModal } from './ModerationConfModal';
import { NewPostBody } from './NewPostBody';
import { NewPostContext } from './NewPostContext';
import { SaveDraftConfModal } from './SaveDraftConfModal';
import { useNewPost } from './useNewPost';
export type { DraftItemSelectHandler } from './NewPostContext';
type Props = {
  closeHandler: (arg0?: boolean) => void;
  spaceSlug?: string;
  pinnedFactiii?: PinnedFactiii;
  uniqueId?: string;
  initialLocation?: {
    latitude: number;
    longitude: number;
  } | null;
  onPostCreated?: (postId: string, latitude?: number, longitude?: number) => void;
  inline?: boolean;
  isBoardPost?: boolean;
  parentPostId?: string;
  parentPost?: Post;
  isPrivatePost?: boolean;
};
export const NewPostModal = props => {
  const $ = _c(20);
  const {
    ctx,
    autoProcess,
    setAutoProcess,
    handleCameraPhoto,
    getRootProps,
    isDragActive,
    privateConfirmDialog
  } = useNewPost(props);
  if (autoProcess) {
    let t0;
    if ($[0] !== props || $[1] !== setAutoProcess) {
      t0 = () => {
        setAutoProcess(false);
        props.closeHandler(false);
      };
      $[0] = props;
      $[1] = setAutoProcess;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    let t1;
    if ($[3] !== handleCameraPhoto || $[4] !== t0) {
      t1 = <Camera closeHandler={t0} setNewPhotoFcn={handleCameraPhoto} />;
      $[3] = handleCameraPhoto;
      $[4] = t0;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    return t1;
  }
  let t0;
  if ($[6] !== getRootProps) {
    t0 = getRootProps();
    $[6] = getRootProps;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  let t1;
  let t2;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ModerationConfModal />;
    t2 = <SaveDraftConfModal />;
    $[8] = t1;
    $[9] = t2;
  } else {
    t1 = $[8];
    t2 = $[9];
  }
  let t3;
  if ($[10] !== isDragActive) {
    t3 = isDragActive && <DragOverlay />;
    $[10] = isDragActive;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <NewPostBody />;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t0 || $[14] !== t3) {
    t5 = <div {...t0}>{t1}{t2}{t3}{t4}</div>;
    $[13] = t0;
    $[14] = t3;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== ctx || $[17] !== privateConfirmDialog || $[18] !== t5) {
    t6 = <NewPostContext value={ctx}>{privateConfirmDialog}{t5}</NewPostContext>;
    $[16] = ctx;
    $[17] = privateConfirmDialog;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
};